import { useState, useEffect } from 'react';
import {useAuth} from "../context/AuthContext"
import axios from 'axios';
import { Link } from 'react-router-dom';
import "./BusinessLogin"
import Quest from './Quest';

const Login = () => {
    const [ loginData, setLoginData] = useState({
        email: "",
        password: "",
    })
    const [message, setMessage] = useState(null)
    const {login} = useAuth()

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/login`, loginData)
            // Zkontrolujeme, zda server v odpovědi obsahuje token
            if (response.data && response.data.userToken) {
                login(response.data.userToken); // Funkce login by měla uložit token (např. do localStorage)
            } else {
                console.log("Chyba přihlášení: No userToken in response")
            }
            setMessage("Přihlášení úspěšné")
        } catch (err) {

            setMessage(err.response?.data?.error || "Přihlášení se nezdařilo")  // Ukázání chybové zprávy
        }
    }
      useEffect(() => {
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        scrollToTop()
      }, [])

    const handleInputChange = (e) => {
        const {name, value} = e.target
        setLoginData((prevData) => ({
            ...prevData,
            [name]:value,
        }))
    }
    return (
<div className='min-height'>

    <div className="login-container">
        <h2 className="login-title">Přihlášení</h2>
        <form className="login-form" onSubmit={handleSubmit}>
            <input
                type="email"
                placeholder="Email"
                name="email"
                value={loginData.email}
                onChange={handleInputChange}
                required
                className="login-input"
            />
            <input
                type="password"
                placeholder="Heslo"
                name="password"
                value={loginData.password}
                onChange={handleInputChange}
                required
                className="login-input"
            />
            <button type="submit" className="login-button">Přihlásit se</button>
        </form>

        {/* Odkazy pod tlačítkem */}
        <div className="login-links">
            <Link to="/forgot-password" className="login-link">Zapomenuté heslo?</Link>
            <Link to="/register" className="login-link">Registrovat</Link>
        </div>
        <Quest />

        {message && <p className="message">{message}</p>}
    </div>
</div>
    );
};

export default Login;